import Toast from '../Toast'
import useNotificationStore from '../../services/notificationStore'
import OperationProgressToast from './OperationProgressToast'

export default function NotificationToastViewport() {
  const toasts = useNotificationStore((state) => state.toasts)
  const dismissToast = useNotificationStore((state) => state.dismissToast)

  return (
    <>
      {(toasts || []).map((toast, index) => {
        if (toast.kind === 'operation-progress') {
          return <OperationProgressToast key={toast.id} toast={toast} />
        }
        return (
          <Toast
            key={toast.id}
            index={index}
            alert={{
              id: toast.id,
              type: toast.title,
              severity: toast.severity,
              message: toast.message,
              persistent: toast.persistent,
            }}
            onDismiss={dismissToast}
            timeoutMs={toast.severity === 'error' ? 8000 : 4000}
          />
        )
      })}
    </>
  )
}
